module.exports = __webpack_public_path__ + "static/profile-photo-5bec4ab20edfe68f1a8318192595b8b1.jpg";